import React, {Component} from 'react'
import {TimelineMax,TweenLite,Linear,Sine,Expo,Power0,Power4} from 'gsap';


class FadeIn extends Component {

  animating=0;
	
  componentDidMount() {

   
        
        this.fade();
   
      

  }

 

  fade = () => {
      const _this = this;
      
      this.animating = 1;
      
      TweenLite.from(this.refs.el,1,{opacity:0,ease:Expo.easeOut,onComplete:function(){

          _this.animating = 0;

      }});

  }

  render () {

    return (

      <div ref="el">

        { this.props.children }

      </div>
    )
  }
}

export default FadeIn



// WEBPACK FOOTER //
// ./src/js/components/FadeIn/FadeIn.jsx